import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import LoadingButton from 'src/components/UI/LoadingButton';
import { makeStyles } from '@material-ui/core/styles';
import Spacer from 'src/components/UI/Spacer';
import WarningIcon from '@material-ui/icons/Warning';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { t } from 'src/lib/language';

const useStyles = makeStyles((theme) => ({
  content: {
    flex: 'none',
    textAlign: 'center',
  },
  title: {
    paddingBottom: theme.spacing(0),
    paddingTop: theme.spacing(0),
  },
  header: {
    marginTop: theme.spacing(1),
    fontSize: '1.2rem',
    fontFamily: 'Qanelas-Bold',
    fontWeight: 'bold',
    color: theme.palette.secondary.main,
  },
  buttons: {
    width: 'fit-content',
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  icon: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '16px',
  },
}));

interface Props {
  onDelete: () => void;
  open: boolean,
  toggleOpen: any,
  loading?: boolean,
  children: any;
}
const DeleteOrganisationDialog = (props:Props) => {
  const classes = useStyles();
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const {
    onDelete,
    open,
    toggleOpen,
    loading,
    children,
  } = props;

  const handleClose = () => {
    toggleOpen();
  };

  const handleDelete = () => {
    onDelete();
  };

  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      aria-labelledby="max-width-dialog-title">
      <DialogContent className={classes.content}>
        <WarningIcon color="error" className={classes.icon} fontSize="large" /><br />
        {children}
      </DialogContent>
      <DialogActions>
        <div className={classes.buttons}>
          <Button
            color="primary"
            onClick={handleClose}
            disabled={loading}>
            {t(lang, 'misc.close')}
          </Button>
          <Spacer space={2} />
          <LoadingButton
            color="primary"
            onClick={handleDelete}
            loading={loading}>
            {t(lang, 'misc.disconnect')}
          </LoadingButton>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteOrganisationDialog;
